import request from '@/utils/request'

export function getReminderList(data) {
  return request({ url: '/admin/reminder/list', method: 'post', data })
}

export function getReminderDetail(data) {
  return request({ url: '/admin/reminder/detail', method: 'post', data })
}

export function createReminder(data) {
  return request({ url: '/admin/reminder/create', method: 'post', data })
}

export function updateReminder(data) {
  return request({ url: '/admin/reminder/update', method: 'post', data })
}

export function deleteReminder(data) {
  return request({ url: '/admin/reminder/delete', method: 'post', data })
}

export function getReminderFollowQrcode(data) {
  return request({ url: '/admin/reminder/follow-qrcode', method: 'post', data })
}

export function toggleReminderWechatNotify(data) {
  return request({ url: '/admin/reminder/toggle-wechat-notify', method: 'post', data })
}
